const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { nodeGraphSearchSchema } from '@/components/loop-visualizations/node-graph/types';
import i18n from '@/lib/translations/i18n';
import { saveLastVisitedMainVisualization, saveLastVisitedView } from '@/lib/utils/loop-visualizations/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/')({
  beforeLoad: ({
    context: {
      flags
    }
  }) => {
    if (!flags.nodeGraphVisualizationEnabled) {
      throw notFound();
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: ({
    params
  }) => {
    const loopId = Number(params.loopId);
    saveLastVisitedView(loopId, {
      type: 'main'
    });
    saveLastVisitedMainVisualization(loopId, 'nodeGraph');
  },
  validateSearch: zodValidator(nodeGraphSearchSchema),
  staticData: {
    topNav: {
      title: i18n.t($ => $.roadmaps.title)
    }
  }
});